<template>
  <figure>
    <v-chart ref="bar" :options="barOption" class="cischart" auto-resize />
  </figure>
</template>
<script>
//* *********************summary***************************//
// html:
// <cisBar :title="title"
// :subTitle="subTitle"
// :x-list="xList"
// :series-name="seriseName"
// :series-data="seriseList" ></cisBar>
//
// js data:
// {
// title: '销量对比图',
// subTitle: '3个月内销量图',
// xList: ['9月','10月','11月'],
// seriseName: ['九阳', '苏泊尔'],
// seriseList: [[133,80,333],[111,222,333]]  //单个系列 [111,222,333]
// }
//* *********************summary***************************//
import 'echarts/lib/chart/bar'
export default {
  name: 'cisBar',
  props: ['title', 'subTitle', 'xList', 'seriesData', 'seriesName', 'isStack', 'unselectedSeries'],
  data() {
    return {
      legends: [],
      series: [],
      unselectedLegends: []
    }
  },
  mounted() {
    this.reloadSeries()
  },
  methods: {
    reloadSeries() {
      this.series = []
      if (Array.isArray(this.seriesName) && this.seriesName.length > 1) {
        this.seriesName.forEach((name, index) => {
          this.series.push({
            type: 'bar',
            name: name,
            stack: this.isStack ? 'stack' : '',
            data: this.seriesData[index]
          })
        })
      } else {
        this.series.push({
          type: 'bar',
          name: this.seriesName,
          stack: this.isStack ? 'stack' : '',
          data: Array.isArray(this.seriesData[0]) ? this.seriesData[0] : this.seriesData
        })
      }
      this.legends = [...this.seriesName]
      this.unselectedLegends = !this.unselectedSeries ? [] : this.unselectedSeries.map(item => {
        return {
          [item]: false
        }
      }).reduce((series = {}, item) => {
        return {
          ...series,
          ...item
        }
      })
    }
  },
  computed: {
    barOption() {
      this.reloadSeries()
      let scrollLegendOption = {}
      if (this.legends.length > 10) {
        scrollLegendOption = {
          type: 'scroll',
          width: '80%'
        }
      } else {
        scrollLegendOption = {}
      }
      return {
        title: {
          text: this.title,
          subtext: this.subTitle
        },
        legend: {
          data: this.legends,
          selected: this.unselectedLegends,
          ...scrollLegendOption
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: this.xList
        },
        yAxis: {
          type: 'value'
        },
        series: this.series
      }
    }
  }
}
</script>
